import React, { memo } from "react";
import { Redirect, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";
import constants from "../Utils/constants";

const SentryRoute = Sentry.withSentryRouting(Route);

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <SentryRoute
      {...rest}
      render={(props) =>
        localStorage.getItem("token") !== null && restricted ? (
          <Redirect to={constants.APPLICATION_ROUTE.DASHBOARD_LIST.ROUTE} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default memo(PublicRoute);
